import { Component } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html'
})
export class BadgeComponent {
  badge1 = 90;
  badge2 = 100;
  notification = "notifications";
}